export enum UserListActionType {
  SET_USERS = 'SET_USERS',
  SET_USER = 'SET_USER',
  SET_USER_FOR_BE = 'SET_USER_FOR_BE',
  SET_CLEAR_USER_BE = 'SET_CLEAR_USER_BE',
  SET_ERROR_MESS = 'SET_ERROR_MESS',
  SET_USERS_LIMIT = 'SET_USER_LIMIT',
  SET_USERS_PAGE_NUMBER = 'SET_USER_PAGE_NUMBER',
  SET_OPEN_USER_PANEL = 'SET_OPEN_USER_PANEL',
  SET_CLOSE_USER_PANEL = 'SET_CLOSE_USER_PANEL',
  SET_START_USER_LOADING = 'SET_START_USER_LOADING',
  SET_STOP_USER_LOADING = 'SET_STOP_USER_LOADING',
}

export enum APIKeysActionType {
  FETCH_API_KEYS = 'FETCH_API_KEYS',
  CREATE_API_KEY = 'CREATE_API_KEY',
  UPDATE_API_KEY = 'UPDATE_API_KEY',
  DELETE_API_KEY = 'DELETE_API_KEY',
}

export enum AuditLogsActionType {
  FETCH_AUDIT_LOGS_SUCCESS = 'FETCH_AUDIT_LOGS_SUCCESS',
  FETCH_AUDIT_LOGS_FAILURE = 'FETCH_AUDIT_LOGS_FAILURE',
}
